export const DASHBOARD_TRUST_CENTER = 'Trust Center';

export const DASHBOARD_AGREEMENT_TERMS = 'Agreement Terms';

export const BASE_KONG = window.config.API_URL;
export const ACCOUNT_ENDPOINT = BASE_KONG;

export const USER_ENDPOINT = BASE_KONG;

export const ROWS_PER_PAGE_AGREEMENTS = 20;

export const TRUSTCENTER_ENDPOINT = BASE_KONG;
export const PERMISSION_ENDPOINT_URI = BASE_KONG;
export const USER_ENDPOINT_URI = BASE_KONG;
export const LOGIN_ENDPOINT_URI = BASE_KONG;
export const PLATFORM_METRICS_URL = 'https://' + window.config.PLATFORM_METRICS_URL;
export const IAM_REDIRECT_URL = 'https://' + window.config.IAM_REDIRECT_URL;
export const AGREEMENT = 'agreements';
export const CONNECTIONS = 'connections';
export const CONNECTIONS_V2 = 'connections-v2';
export const AGREEMENT_REPORT = 'agreement-report';
export const CREATE_CONNECTION = 'create-connection';
export const TRIMBLE_AUTOMATION = 'trimble_automation';
export const SHARING_AGREEMENTS = 'sharing-agreements';
export const SHARING_AGREEMENTS_V2 = 'sharing-agreements-v2';
export const SHARING_AGREEMENTS_REPORT = 'sharing-agreements-report';
export const CARRIER_V2_CONNECTIONS_PATH = '/connections/v2';
export const CARRIER_V2_PROVIDER_PATH = '/connections/v2/provider';
export const CARRIER_V2_AGREEMENTS_PATH = '/connections/v2/agreements';

export const GPS_ONLY = 'GPS Data(Only)';
export const AGREEMENT_SHIPPER = 'TMS';
export const AGREEMENT_TRUCK = 'MOB';
export const TERMS_V2_ENABLED = 'true' === window.config.TERMS_V2_API_ENABLED;

export const ACCOUNT_DETAILS = 'account-details';
export const AGREEMENT_TYPE_VISIBILITY = 'VISIBILITY PROVIDER';
export const AGREEMENT_TYPE_OEM = 'OEM';
export const AGREEMENT_TYPE_VISIBILITY_UI = 'Visibility';
export const ACCOUNT_TYPE_VISIBILITY = 'Visibility Provider';
export const ACCOUNT_TYPE_VISIBILITY_API = 'Visibility_Provider';
export const VISIBILITY_PROVIDER = 'VISIBILITY_PROVIDER';
export const ACCOUNT_TYPE_SHIPPER = 'Shipper';
export const SHIPPER_GROUP_NOT_APPLICABLE = 'Not Applicable';
export const SHIPPER_CODE_ALL_SHIPPER = 'All Shippers';
export const SHIPMENT_IDENTIFIERS_NOT_APPLICABLE = SHIPPER_GROUP_NOT_APPLICABLE;
export const BLANK_DATASOURCE_ID = -1000;
export const ACCOUNT_TYPE_VENDOR = 'Vendor';
export const TRUSTCENTER_PAGES = [CONNECTIONS, AGREEMENT, CREATE_CONNECTION];
export const TRUSTCENTER_V2_PAGES = [CONNECTIONS_V2];
export const SHARING_AGREEMENTS_PAGES = [SHARING_AGREEMENTS];
export const TRUSTCENTER_AGREEMENT_REPORT_PAGES = [AGREEMENT_REPORT];

export const RESERVED_GROUPNAMES = ['NOT APPLICABLE'];

export const CLEAR_ICON_WIDTH = 45;

export const ACCOUNTS_RESOURCE = 'Accounts';
export const ACCOUNTS_FEATURE = '/accounts';

export const TRUSTCENTER_RESOURCE = 'Trust Center';
export const USER_V2_RESOURCE = 'UserServiceV2';
export const TRUSTCENTER_FEATURE = '/trustcenter';
export const TRUSTCENTER_AGREEMENT_REPORT_FEATURE = '/signed-agreement';
export const AGREEMENT_REPORT_FEATURE = 'termsandconditions';
export const TRUSTCENTER_CLIENT_CENTER_FEATURE = '/clientcenter';
export const CONNECTION_ACTIVE_STATUS = 'ACTIVE';
export const CONNECTION_INACTIVE_STATUS = 'INACTIVE';

export const ROUTES = {
    ROOT: '/',
    UNAUTHORIZED_ACCESS: '/unauthorized-access',
    IDENTITY_PROVIDER_QUERY_PARAM: '/?identity_provider=trimble_automation',
    CONNECTIONS: '/connections',
    CONNECTIONS_V2: CARRIER_V2_CONNECTIONS_PATH,
    SHARING_AGREEMENTS: '/sharing-agreements',
    SHARING_AGREEMENTS_V2: '/sharing-agreements-v2',
    SHARING_AGREEMENTS_REPORT: '/sharing-agreements-report'
};

export const ERROR_PATHS = [
    'unauthorized-access',
    'restricted-access',
    'restricted-application-access'
];

export const RESTRICTED = 'Restricted';

export const AGREEMENT_GROUP_FIELD = {
    group_name: '',
    status: true
};

export const IS_REQUIRED = ' is required';
export const IS_INVALID = ' is invalid';

export const CREATE_CONNECTION_OPERATION = 'Create Connection';
export const CREATE_AGREEMENT_OPERATION = 'Create Agreement';
export const UPDATE_AGREEMENT_OPERATION = 'Update Agreement';

export const CONNECTION_STATUS_CHECK = 'Check Connection Status';

export const DEFAULT_DELIVER_TO_OTHER_PARTIES_STATUS = false;

export const TRUSTCENTER_EVENT_DEV_NETWORK_URLS = [
    {
        name: 'position',
        url: 'position'
    },
    {
        name: 'stop',
        url: 'stopstatus'
    },
    {
        name: 'shipment',
        url: 'shipmentstatus'
    },
    {
        name: 'location',
        url: 'location'
    },
    {
        name: 'containertype',
        url: '#'
    },
    {
        name: 'temperature',
        url: '#'
    },
    {
        name: 'shipment-status',
        url: 'shipmentstatus'
    },
    {
        name: 'load-tender-response',
        url: 'loadtenderresponse'
    }
];

export const TRUSTCENTER_ALL_EVENTS = 'All Events';
export const AGREEMENTS_NEW_GROUP = 'newGroup';
export const AGREEMENTS_EXISTING_GROUP = 'existingGroup';

export const DASHBOARD_ROUTE = '/dashboard';
export const USER_LOGIN = 'LOGIN';
export const USER_LOGOUT = 'LOGOUT';
export const USER_RENEWAL = 'SESSION_RENEWAL';
export const SCOPE_NAME = 'openid ' + window.config.TC_APP_NAME;
export const AUTHORITY_NAME = 'https://' + window.config.AUTH_NAME;
export const REDIRECT_URI = 'https://' + window.config.TC_APP_URL + '/ui/signin';
export const LOGOUT_REDIRECT_URI = 'https://' + window.config.TC_APP_URL;
export const TC_KEY_ID = window.config.TC_APP_KEY;

export const SYSTEM_ADMIN = 'SYSTEM_ADMIN';
export const VISIBILITY_ADMIN = 'VISIBILITY_ADMIN';
export const SUPPORT_USER = 'SUPPORT_USER';
export const CARRIER_ADMIN = 'ACCOUNT_ADMIN';
export const CARRIER_USER = 'USER';

export const BASE = 'BASE';
export const ADD_ON = 'ADD_ON';

//Fuel Vendor
export const FUEL_VENDOR_BATCH_TYPE = 'Batch';
export const FUEL_VENDOR_INTERACTIVE_TYPE = 'Interactive';
export const BATCH_CONNECTION_TYPES = ['FTP', 'sFTP'];
export const DIRECTION_TYPES = ['Inbound', 'Outbound', 'Bidirectional'];
export const DEFAULT_SHIPPER_IDENTIFIERS = [
    "ShipperIdentifiers[OrganizationIdentifierType=3].Value='RYEAMB' and $exists(ReferenceNumbersList[Key='SID'])",
    "ShipperIdentifiers[OrganizationIdentifierType=3].Value='RYEAMB' and $exists(ReferenceNumbersList[Key='BOL'])",
    "ShipperIdentifiers[OrganizationIdentifierType=3].Value='RYEAMB' and $exists(ReferenceNumbersList[Key='BL#'])"
];
export const INTEGRATION_OPTIONS = ['Realtime', 'Fleet'];
export const FUEL_EDIT_MODE = 'edit';
export const FUEL_VIEW_MODE = 'view';
export const FUEL_VENDOR_ENDPOINT = BASE_KONG;
export const FUEL_DUPLICATE_ERROR = 'Configuration already exists';
export const FUEL_VENDOR_DETAILS = 'fuel-vendor-details';
export const FUELVENDORSUMMARY = 'fuelvendorsummary';
export const FUELVENDOR_PAGES = [FUELVENDORSUMMARY, FUEL_VENDOR_DETAILS];
export const FUELVENDOR_RESOURCE = 'Fuel-Vendor';
export const FUELVENDOR_FEATURE = 'fuelvendor';

export const PEOPLE_NET_ID = 'people_net_id';
export const TENANT_ID = 'tenant_id';
export const COULD_NOT_FETCH_SIGNED_TERMS = "Couldn't fetch singed terms.";
export const COULD_NOT_SAVE_AGREEMENT = "Couldn't save signed terms.";
export const COULD_NOT_FETCH_TERMS = "Couldn't fetch terms.";

export const ACTIVITY_TYPE_CREATE = 'create';
export const ACTIVITY_TYPE_EDIT = 'edit';
export const DVIR_DETAIL_TEXT =
    "A driver's vehicle inspection report (DVIR) is a document that a truck or bus driver fills out at the end of the day to let his or her company know about any unsafe or missing equipment on the vehicle.";
export const DRIVER_DETAIL_TEXT =
    'A Driver sharing agreement will handle messages related to creating, updating, and deleting driver management events within transportation.';
export const USER_STATUS_INACTIVE = 'INACTIVE';
export const TRUE = 'true';
export const ACCOUNT_TYPE_DVIR = 'DVIR';
export const ACCOUNT_TYPE_DRIVER = 'DRIVER';
export const AGREEMENT_TYPE_FUEL_TAX = 'FUEL TAX';
export const AGREEMENT_TYPE_CTA = 'CYCLE TIME AVAILABILITY';
export const HIDE_ACCOUNT_TYPES = [ACCOUNT_TYPE_DVIR, AGREEMENT_TYPE_FUEL_TAX, AGREEMENT_TYPE_CTA];
export const DVIR_TYPE_ENABLED = window.config.DVIR_AGREEMENT_ENABLED;
export const VENDOR_AGREEMENT_TYPES = [
    ACCOUNT_TYPE_DVIR,
    'Fuel Tax',
    'Cycle Time Availability',
    'Driver'
];
export const VENDOR_AGREEMENT_EMPTY_TEXT = `Select a Connection Type and click "Add Sharing Agreement" to begin sending data to this Partner`;
export const FUEL_TAX_TEXT_1 = `Certain CMVs that travel in more than one U.S. state or Canadian province need to file a report of all motor fuel taxes, noting miles traveled and the amount of fuel consumed.`;
export const FUEL_TAX_TEXT_2 = `The International Fuel Tax Agreement (IFTA) is an agreement between Canadian provinces and some U.S. states to streamline the reporting of fuel use and ensure the proper amount of tax is paid and attributed to the correct state or province.`;
export const CTA_TEXT = `Cycle time is the number of minutes needed to make a round trip on the route, including layover/recovery time. Cycle time is important for several reasons, including playing a part in the formula used for determining the number of vehicles needed to provide a given level of service on a route.`;
export const AGREEMENT_TYPE_CTA_SHORT = 'CTA';

export const CONNECTION_PENDING_MESSAGE =
    'Prior to accepting or rejecting sharing agreements, it is necessary to accept the connection';

export const ENVIRONMENT_NAME = window.config.ENVIRONMENT;
export const DOMAIN_NAME = window?.config?.API_URL;
export const AUTH_WORKFLOW = 'auth_workflow';

//Sharing agreements
export const SHARING_AGREEMENT_STATUS = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED'
};

export const SHARING_AGREEMENT_STATUS_V2 = {
    PENDING: 'Pending',
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected'
};

export const RESUBMIT_REQUEST = 'Resubmit Request';

export const GET_AGREEMENTS_ERROR = 'Failed to fetch shared agreements';
export const UPDATE_AGREEMENTS_ERROR = 'Failed to update shared agreement';

export const UPDATE_AGREEMENTS_SUCCESS = 'Sharing agreement updated successfully';

export const CONNECTION_TYPES = {
    VENDOR: 'VENDOR',
    VISIBILITY_PROVIDER: 'VISIBILITY PROVIDER'
};

export const VISIBILITY_AGREEMENT_STATUS = [
    {
        label: 'Accept',
        value: 'ACCEPTED'
    },
    {
        label: 'Reject',
        value: 'REJECTED'
    }
];

export const V2_SHARING_AGREEMENTS_EVENTS = [
    {
        name: 'com.trimble.trans.track.position.event',
        messageType: 'track-position'
    },
    {
        name: 'com.trimble.trans.track.location.event',
        messageType: 'track-location'
    },
    {
        name: 'com.trimble.trans.track.shipment.event',
        messageType: 'track-shipment'
    },
    {
        name: 'com.trimble.trans.track.stopstatus.event',
        messageType: 'stopstatus'
    }
];

export const PAGE = 1;
export const PAGE_SIZE = 10;
export const SORT_ORDER = {
    ASC: 'ASC',
    DESC: 'DESC'
};
export const SORT_FIELD = 'name';
export const SORT_FIELD_V1_PROVIDER = 'name';
export const SORT_FIELD_V2_PROVIDER = 'createdAt';

export const VALIDATE_TYPE = {
    MACROPOINT_ID: 'macropointId',
    PATH: 'path'
};

export const FIELD_ERROR = {
    MACROPOINT_ID: 'ID must contain only numeric characters'
};

export const FOURKITES = 'FourKites';

export const MAX_PAGE_SIZE = 9999;
export const UNSAVED_CHANGES_MESSAGE =
    'Are you sure you want to navigate to another page without saving your changes?';
export const UNSAVED_RESET_MESSAGE =
    'Are you sure you want to reset? Unsaved changes will be lost and the form will return to the last saved state.';
